export enum CallerSessionStatus {
  NotTakingCalls = 'NotTakingCalls',
  TakingCalls = 'TakingCalls',
  ConsideringPushedCall = 'ConsideringPushedCall',
  InCallerSession = 'InCallerSession',
}
